import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@last_home_card_index';
const TOTAL_ITEMS = 7;

export async function getNextHomeCardIndex(): Promise<number> {
  const stored = await AsyncStorage.getItem(STORAGE_KEY);
  const lastIndex = stored ? Number(stored) : 0;
  const nextIndex = (lastIndex % TOTAL_ITEMS) + 1;

  await AsyncStorage.setItem(STORAGE_KEY, String(nextIndex));

  return nextIndex;
}
